import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { AccountStatusEnum } from '../enums/account-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function accountStatusToColor(status: AccountStatusEnum): string {
	switch (status) {
		case AccountStatusEnum.ACTIVE:
			return RecordColorEnum.GREEN;

		case AccountStatusEnum.ON_HOLD:
			return RecordColorEnum.RED;

		case AccountStatusEnum.CLOSED:
			return RecordColorEnum.SLATE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
